module.exports = __webpack_public_path__ + "img/line-end-4.f74776a1.svg";